import { createCreateActionType, createCreateFetchingKey } from "@multiweb/reactUtils";

/**
 * Jméno modulu menu. Slouží pro jednoznačnou identifikaci modulu.
 */
export const NAME = "frames";

const createFetchingKey = createCreateFetchingKey(NAME);

/**
 * Klíč pro indikaci načítání lokalizace pro statické položky menu ve fetching modulu.
 */
export const FETCHING_KEY_STATIC_FRAMES_ITEMS_LOCALIZATION = createFetchingKey("FETCHING_KEY_STATIC_FRAMES_ITEMS_LOCALIZATION");

/**
 * Klíč pro indikaci načítání lokalizací, které jsou nastavené pro daný frame.
 */
export const FETCHING_KEY_FRAME_LOCALIZATIONS = createFetchingKey("FETCHING_KEY_FRAME_LOCALIZATIONS");

const createActionType = createCreateActionType(NAME);

/**
 * Typ akce pro inicializaci framu.
 */
export const INIT_FRAME = createActionType("INIT_FRAME");

/**
 * Typ akce pro inicializaci framu, který využívá dataSource.
 */
export const INIT_FRAME_WITH_DATASOURCE = createActionType("INIT_FRAME_WITH_DATASOURCE");

/**
 * Typ akce pro smazání framu.
 */
export const DELETE_FRAME = createActionType("DELETE_FRAME");

/**
 * Typ akce pro zapnutí/vypnutí režimu výběru více záznamů.
 */
export const SET_MULTISELECT_MODE = createActionType("SET_MULTISELECT_MODE");

/**
 * Typ akce pro výběr záznamů daných identifikátory.
 */
export const SET_SELECTED_RECORDS = createActionType("SET_SELECTED_RECORDS");

/**
 * Typ akce pro výběr záznamu daného identifikátorem.
 */
export const TRY_SELECT_RECORD = createActionType("TRY_SELECT_RECORD");

/**
 * Typ akce pro nastavení informace o tom, zda je možné načítat další data.
 */
export const SET_CAN_VALUE_LOAD = createActionType("SET_CAN_VALUE_LOAD");

/**
 * Typ akce pro nastavení template, pomocí kterého se vykreslí DataRow.
 */
export const SET_ROW_TEMPLATE = createActionType("SET_ROW_TEMPLATE");

/**
 * Typ akce pro nastavení informace o tom, do jaké oblasti se zobrazují akce záznamu.
 */
export const SET_ACTION_AREA = createActionType("SET_ACTION_AREA");

/**
 * Typ akce pro nastavení informace o tom, zda se má zobrazit hlavička.
 */
export const SET_SHOW_HEADER = createActionType("SET_SHOW_HEADER");

/**
 * Typ akce pro nastavení informace o tom, zda se mají data načítat postupně při scrollovaní nebo se zobrazit pouze do viditelné části.
 */
export const SET_LOAD_ON_SCROLL = createActionType("SET_LOAD_ON_SCROLL");

/**
 * Typ akce pro nastavení informace o tom, zda je frame interaktivní, zda s ním lze pracovat a pouštět nad ním akce.
 */
export const SET_INTERACTIVE = createActionType("SET_INTERACTIVE");

/**
 * Typ akce pro určení, zda se může zapnout režim výběru více záznamů.
 */
export const SET_ALLOW_MULTISELECT = createActionType("SET_ALLOW_MULTISELECT");

/**
 * Typ akce pro odchycení kliknutí na záznam.
 */
export const HANDLE_RECORD_CLICK = createActionType("HANDLE_RECORD_CLICK");

/**
 * Typ akce pro určení, zda je frame viditelný na multiwebu.
 */
export const SET_MULTIWEB_VISIBILITY = createActionType("SET_MULTIWEB_VISIBILITY");

/**
 * Typ akce pro určení, zda je frame viditelný na multiwebu.
 */
export const SET_EMPTY_MESSAGE_CUSTOMIZATION = createActionType("SET_EMPTY_MESSAGE_CUSTOMIZATION");

/**
 * Obsah, který se zobrazí v buňce, pokud nebude mít hodnotu.
 */
export const LLF_EMPTY_VALUE = "-";

/**
 * Klíč pro registraci rendereru atributu roleUsers.
 */
export const ROLE_USERS_ATTRIBUTE_RENDERER = "RoleUsersAttributeRenderer";

/**
 * Klíč pro registraci rendereru atributu participantType.
 */
export const PARTICIPANT_TYPE_ATTRIBUTE_RENDERER = "ParticipantTypeAttributeRenderer";
